import { render, staticRenderFns } from "./studentDisclose.vue?vue&type=template&id=79c4fe90&scoped=true&"
import script from "./studentDisclose.vue?vue&type=script&lang=js&"
export * from "./studentDisclose.vue?vue&type=script&lang=js&"
import style0 from "./studentDisclose.vue?vue&type=style&index=0&id=79c4fe90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c4fe90",
  null
  
)

export default component.exports